/**
 * Signature Collection — Box Size ATC workflow.
 * Step 1: visual Box Size cards → Step 2: shipping (same modal) → product-form submit.
 */
(function () {
  "use strict";

  var ROOT_ID = "ks-box-size-atc-workflow";
  var CONFIG_SELECTOR = "[data-ks-box-size-atc-workflow-config]";

  function getConfig(fromEl) {
    var root =
      (fromEl && fromEl.closest && fromEl.closest(".shopify-section")) ||
      document;
    var node = root.querySelector
      ? root.querySelector(CONFIG_SELECTOR)
      : null;
    if (!node) node = document.querySelector(CONFIG_SELECTOR);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (_) {
      return null;
    }
  }

  function getKS() {
    return window.KSShippingOption || null;
  }

  function getGate() {
    return window.KSShippingGate || null;
  }

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  var WorkflowUI = {
    root: null,
    panel: null,
    eyebrowEl: null,
    titleEl: null,
    productEl: null,
    helperEl: null,
    sizeStep: null,
    sizeMount: null,
    shippingStep: null,
    shippingOptions: null,
    estimateWrap: null,
    estimateValue: null,
    errorEl: null,
    backBtn: null,
    primaryBtn: null,
    cancelBtn: null,
    previousFocus: null,
    keyHandler: null,
    config: null,
    form: null,
    productFormHost: null,
    selectedVariantId: "",
    selectedShipping: "",
    step: "size",
    transitioning: false,

    ensureMounted: function () {
      if (this.root) return;

      var html =
        '<div id="' +
        ROOT_ID +
        '" class="ks-box-size-atc-workflow" hidden>' +
        '<div class="ks-box-size-atc-workflow__backdrop" data-ks-wf-close tabindex="-1"></div>' +
        '<div class="ks-box-size-atc-workflow__panel" role="dialog" aria-modal="true" aria-labelledby="ks-box-size-atc-workflow-title">' +
        '<button type="button" class="ks-box-size-atc-workflow__close modal__close-button" data-ks-wf-close aria-label="Close">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close"><use href="#icon-close" /></svg>' +
        "</button>" +
        '<div class="ks-box-size-atc-workflow__heading">' +
        '<button type="button" class="ks-box-size-atc-workflow__back" data-ks-wf-back hidden>' +
        '<svg class="ks-box-size-atc-workflow__back-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
        '<path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>' +
        "</svg>" +
        "<span>Back</span>" +
        "</button>" +
        '<p class="ks-box-size-atc-workflow__eyebrow" data-ks-wf-eyebrow>Step 1 of 2</p>' +
        "</div>" +
        '<h2 id="ks-box-size-atc-workflow-title" class="ks-box-size-atc-workflow__title" data-ks-wf-title>Choose your box size</h2>' +
        '<p class="ks-box-size-atc-workflow__product" data-ks-wf-product hidden></p>' +
        '<p class="ks-box-size-atc-workflow__helper" data-ks-wf-helper></p>' +
        '<div class="ks-box-size-atc-workflow__steps">' +
        '<div class="ks-box-size-atc-workflow__step is-active" data-ks-wf-step="size">' +
        '<div data-ks-wf-size-mount></div>' +
        "</div>" +
        '<div class="ks-box-size-atc-workflow__step" data-ks-wf-step="shipping" hidden>' +
        '<div class="ks-box-size-atc-workflow__options" data-ks-wf-shipping-options role="radiogroup" aria-label="Shipping option"></div>' +
        '<button type="button" class="ks-box-size-atc-workflow__change" data-ks-wf-change-shipping hidden>Change shipping option</button>' +
        '<div class="ks-box-size-atc-workflow__estimate" data-ks-wf-estimate-wrap hidden>' +
        '<span class="ks-box-size-atc-workflow__estimate-label">Estimated ship date:</span>' +
        '<strong class="ks-box-size-atc-workflow__estimate-value" data-ks-wf-estimate></strong>' +
        "</div>" +
        '<p class="ks-box-size-atc-workflow__price" data-ks-wf-price hidden></p>' +
        '<div class="ks-box-size-atc-workflow__promo" data-ks-wf-promo>' +
        '<label class="ks-box-size-atc-workflow__promo-label" for="ks-wf-promo-input">Promo Code</label>' +
        '<div class="ks-box-size-atc-workflow__promo-row">' +
        '<input id="ks-wf-promo-input" class="ks-box-size-atc-workflow__promo-input" data-ks-wf-promo-input type="text" autocomplete="off" spellcheck="false" placeholder="Enter promo code" aria-describedby="ks-wf-promo-status ks-wf-promo-error">' +
        '<button type="button" class="button button--secondary ks-box-size-atc-workflow__promo-apply" data-ks-wf-promo-apply>Apply</button>' +
        "</div>" +
        '<p id="ks-wf-promo-status" class="ks-box-size-atc-workflow__promo-status" data-ks-wf-promo-status role="status"></p>' +
        '<p id="ks-wf-promo-error" class="ks-box-size-atc-workflow__promo-error" data-ks-wf-promo-error role="alert" hidden></p>' +
        "</div>" +
        "</div>" +
        "</div>" +
        '<p class="ks-box-size-atc-workflow__error" data-ks-wf-error role="alert" hidden></p>' +
        '<div class="ks-box-size-atc-workflow__progress" data-ks-wf-progress hidden>' +
        '<div class="ks-box-size-atc-workflow__progress-bar" data-ks-wf-progress-bar></div>' +
        '<p class="ks-box-size-atc-workflow__progress-label" data-ks-wf-progress-label>Preparing order…</p>' +
        "</div>" +
        '<div class="ks-box-size-atc-workflow__actions">' +
        '<button type="button" class="button button--secondary" data-ks-wf-cancel>Cancel</button>' +
        '<button type="button" class="button button--primary" data-ks-wf-primary>Continue</button>' +
        "</div>" +
        "</div>" +
        "</div>";

      document.body.insertAdjacentHTML("beforeend", html);

      this.root = document.getElementById(ROOT_ID);
      this.panel = this.root.querySelector(".ks-box-size-atc-workflow__panel");
      this.eyebrowEl = this.root.querySelector("[data-ks-wf-eyebrow]");
      this.titleEl = this.root.querySelector("[data-ks-wf-title]");
      this.productEl = this.root.querySelector("[data-ks-wf-product]");
      this.helperEl = this.root.querySelector("[data-ks-wf-helper]");
      this.sizeStep = this.root.querySelector('[data-ks-wf-step="size"]');
      this.sizeMount = this.root.querySelector("[data-ks-wf-size-mount]");
      this.shippingStep = this.root.querySelector(
        '[data-ks-wf-step="shipping"]'
      );
      this.shippingOptions = this.root.querySelector(
        "[data-ks-wf-shipping-options]"
      );
      this.estimateWrap = this.root.querySelector("[data-ks-wf-estimate-wrap]");
      this.estimateValue = this.root.querySelector("[data-ks-wf-estimate]");
      this.changeShippingBtn = this.root.querySelector("[data-ks-wf-change-shipping]");
      this.priceEl = this.root.querySelector("[data-ks-wf-price]");
      this.promoInput = this.root.querySelector("[data-ks-wf-promo-input]");
      this.promoStatus = this.root.querySelector("[data-ks-wf-promo-status]");
      this.promoError = this.root.querySelector("[data-ks-wf-promo-error]");
      this.errorEl = this.root.querySelector("[data-ks-wf-error]");
      this.backBtn = this.root.querySelector("[data-ks-wf-back]");
      this.progressEl = this.root.querySelector("[data-ks-wf-progress]");
      this.progressLabel = this.root.querySelector("[data-ks-wf-progress-label]");
      this.primaryBtn = this.root.querySelector("[data-ks-wf-primary]");
      this.cancelBtn = this.root.querySelector("[data-ks-wf-cancel]");

      this.buildShippingOptions();

      var self = this;
      this.root.addEventListener("click", function (event) {
        if (event.target.closest("[data-ks-wf-close], [data-ks-wf-cancel]")) {
          event.preventDefault();
          self.close();
          return;
        }

        if (event.target.closest("[data-ks-wf-back]")) {
          event.preventDefault();
          if (self._adding) return;
          if (self.hasSizeChoices()) self.goToSizeStep();
          return;
        }

        if (event.target.closest("[data-ks-wf-change-shipping]")) {
          event.preventDefault();
          self.expandShipping();
          return;
        }

        if (event.target.closest("[data-ks-wf-promo-apply]")) {
          event.preventDefault();
          self.applyPromo();
          return;
        }

        if (event.target.closest("[data-ks-wf-promo-clear]")) {
          event.preventDefault();
          self.clearPromo();
          return;
        }

        if (event.target.closest("[data-ks-wf-primary]")) {
          event.preventDefault();
          self.onPrimary();
          return;
        }

        var shipBtn = event.target.closest(".ks-box-size-atc-workflow__option");
        if (shipBtn) {
          event.preventDefault();
          self.selectShipping(shipBtn.dataset.value);
          self.collapseShipping(false);
        }
      });

      this.root.addEventListener("keydown", function (event) {
        if (event.key !== "Enter") return;
        if (!event.target.closest("[data-ks-wf-promo-input]")) return;
        event.preventDefault();
        self.applyPromo();
      });

      this.root.addEventListener("change", function (event) {
        var radio = event.target.closest(
          '.ks-box-size-options input[type="radio"]'
        );
        if (!radio) return;
        self.onSizeSelected(radio);
      });

      this.keyHandler = function (event) {
        if (!self.root || self.root.hidden) return;
        if (event.code === "Escape") {
          event.preventDefault();
          self.close();
          return;
        }
        if (event.code === "Tab") {
          self.trapFocus(event);
        }
      };
      document.addEventListener("keydown", this.keyHandler);
      this.bindViewport();
    },

    buildShippingOptions: function () {
      if (!this.shippingOptions) return;
      this.shippingOptions.innerHTML = "";
      var KS = getKS();
      var options = KS ? KS.getShippingOptions() : [];

      options.forEach(function (value) {
        var est = KS.getEstimatedShipDateForOption(value);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "ks-box-size-atc-workflow__option";
        btn.setAttribute("role", "radio");
        btn.setAttribute("aria-checked", "false");
        btn.dataset.value = value;
        btn.innerHTML =
          '<span class="ks-box-size-atc-workflow__option-label">' +
          value +
          "</span>" +
          '<span class="ks-box-size-atc-workflow__option-date">' +
          est +
          "</span>";
        this.shippingOptions.appendChild(btn);
      }, this);
    },

    applyAccent: function (color) {
      if (!this.root || !color) return;
      this.root.style.setProperty("--ks-wf-accent", color);
      this.root.style.setProperty(
        "--ks-wf-accent-soft",
        "color-mix(in srgb, " + color + " 12%, white)"
      );
    },

    showError: function (message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || "";
      this.errorEl.hidden = !message;
    },

    onSizeSelected: function (radio) {
      if (!radio || radio.disabled) return;
      var next = String(radio.getAttribute("data-variant-id") || "").trim();
      if (/^\d+$/.test(next)) this.selectedVariantId = next;
      this.showError("");
    },

    hasSizeChoices: function () {
      return !!(
        this.sizeMount &&
        this.sizeMount.querySelector('input[type="radio"]')
      );
    },

    selectedSizeLabel: function () {
      if (this.sizeMount) {
        var checked = this.sizeMount.querySelector(
          'input[type="radio"]:checked'
        );
        if (checked) {
          return (
            this.sizeMount.querySelector('label[for="' + checked.id + '"]') ||
            (checked.labels && checked.labels[0]) ||
            null
          );
        }
      }
      return this.promoEl || null;
    },

    formatMoney: function (cents) {
      var api = window.KSPromoPreview;
      if (api && typeof api.formatMoney === "function") return api.formatMoney(cents);
      return "$" + ((Math.max(0, Number(cents) || 0) / 100).toFixed(2));
    },

    showPromoError: function (message) {
      if (!this.promoError) return;
      this.promoError.textContent = message || "";
      this.promoError.hidden = !message;
    },

    renderPromoStatus: function () {
      var api = window.KSPromoPreview;
      if (!this.promoStatus) return;
      var summary = api && typeof api.describe === "function" ? api.describe() : null;
      var label = this.selectedSizeLabel();
      var preview =
        api && label && typeof api.previewForElement === "function"
          ? api.previewForElement(label)
          : null;

      if (this.priceEl) {
        var base = label ? Number(label.getAttribute("data-ks-base-cents")) : NaN;
        if (preview && preview.discountedCents != null && Number.isFinite(base)) {
          this.priceEl.hidden = false;
          this.priceEl.innerHTML =
            '<span class="ks-box-size-atc-workflow__price-was">' +
            this.formatMoney(base) +
            '</span><span aria-hidden="true"> → </span><span class="ks-box-size-atc-workflow__price-now">' +
            this.formatMoney(preview.discountedCents) +
            "</span>";
        } else if (Number.isFinite(base)) {
          this.priceEl.hidden = false;
          this.priceEl.textContent = this.formatMoney(base);
        } else {
          this.priceEl.hidden = true;
          this.priceEl.textContent = "";
        }
      }

      if (!summary) {
        this.promoStatus.textContent = "";
        return;
      }

      var heading = summary.primary || summary.code;
      this.promoStatus.textContent = "";
      var applied = document.createElement("span");
      applied.className = "ks-box-size-atc-workflow__promo-applied";
      applied.textContent = "✓ Promo applied";
      this.promoStatus.appendChild(applied);
      var codeEl = document.createElement("span");
      codeEl.className = "ks-box-size-atc-workflow__promo-code";
      codeEl.textContent = heading;
      this.promoStatus.appendChild(codeEl);
      (summary.lines || []).forEach(function (line) {
        var seen = {};
        var names = (line.variants || [])
          .filter(function (name) {
            var key = String(name || "").trim().toLowerCase();
            if (!key || seen[key]) return false;
            seen[key] = true;
            return true;
          })
          .join(", ");
        var row = document.createElement("span");
        row.className = "ks-box-size-atc-workflow__promo-line";
        row.textContent = (names ? names + ": " : "") + (line.label || line.code);
        this.promoStatus.appendChild(row);
      }, this);
      var clearBtn = document.createElement("button");
      clearBtn.type = "button";
      clearBtn.className = "ks-box-size-atc-workflow__promo-clear";
      clearBtn.setAttribute("data-ks-wf-promo-clear", "");
      clearBtn.textContent = "Remove / Change";
      this.promoStatus.appendChild(clearBtn);
      if (this.promoInput) this.promoInput.value = heading;
    },

    applyPromo: function () {
      var api = window.KSPromoPreview;
      var value = this.promoInput ? this.promoInput.value : "";
      this.showPromoError("");
      if (!api || typeof api.resolveInput !== "function") {
        this.showPromoError("Promo code not found");
        return;
      }
      var resolved = api.resolveInput(value);
      if (!resolved || !resolved.ok) {
        this.showPromoError((resolved && resolved.message) || "Promo code not found");
        return;
      }
      if (typeof api.applyInput === "function") api.applyInput(value);
      var label = this.selectedSizeLabel();
      if (label && typeof api.appliesToElement === "function" && !api.appliesToElement(label)) {
        if (typeof api.clear === "function") api.clear();
        this.showPromoError("Promo code does not apply to this product/size");
        this.renderPromoStatus();
        return;
      }
      var preview =
        label && typeof api.previewForElement === "function"
          ? api.previewForElement(label)
          : null;
      if (!resolved.isCampaign && !preview) {
        if (typeof api.clear === "function") api.clear();
        this.showPromoError("Promo code does not apply to this product/size");
        this.renderPromoStatus();
        return;
      }
      this.renderPromoStatus();
    },

    clearPromo: function () {
      var api = window.KSPromoPreview;
      if (api && typeof api.clear === "function") api.clear();
      if (this.promoInput) this.promoInput.value = "";
      this.showPromoError("");
      this.renderPromoStatus();
    },

    expandShipping: function () {
      if (!this.shippingOptions) return;
      this.shippingOptions.classList.remove("is-collapsed", "is-gathering");
      this.shippingOptions.querySelectorAll(".ks-box-size-atc-workflow__option").forEach(function (btn) {
        btn.style.removeProperty("--ks-stack-y");
        btn.hidden = false;
      });
      if (this.changeShippingBtn) this.changeShippingBtn.hidden = true;
      var selected = this.shippingOptions.querySelector(".is-selected");
      (selected || this.shippingOptions.querySelector(".ks-box-size-atc-workflow__option"))?.focus?.();
    },

    collapseShipping: function (immediate) {
      if (!this.shippingOptions || !this.selectedShipping) return;
      var selected = this.shippingOptions.querySelector(".is-selected");
      if (!selected) return;
      var selectedTop = selected.offsetTop;
      this.shippingOptions.querySelectorAll(".ks-box-size-atc-workflow__option").forEach(function (btn) {
        if (btn === selected) return;
        btn.style.setProperty("--ks-stack-y", selectedTop - btn.offsetTop + "px");
      });
      var self = this;
      var finish = function () {
        self.shippingOptions.classList.add("is-collapsed");
        self.shippingOptions.classList.remove("is-gathering");
        if (self.changeShippingBtn) self.changeShippingBtn.hidden = false;
      };
      if (immediate || prefersReducedMotion()) {
        finish();
        return;
      }
      this.shippingOptions.classList.add("is-gathering");
      window.setTimeout(finish, 220);
    },

    selectShipping: function (value) {
      var KS = getKS();
      this.selectedShipping = KS
        ? KS.normalizeShippingOption(value || "")
        : String(value || "").trim();

      this.root
        .querySelectorAll(".ks-box-size-atc-workflow__option")
        .forEach(
          function (btn) {
            var active = btn.dataset.value === this.selectedShipping;
            btn.classList.toggle("is-selected", active);
            btn.setAttribute("aria-checked", active ? "true" : "false");
          }.bind(this)
        );

      var estimated = KS
        ? KS.getEstimatedShipDateForOption(this.selectedShipping)
        : "";
      if (estimated && this.estimateWrap && this.estimateValue) {
        this.estimateValue.textContent = estimated;
        this.estimateWrap.hidden = false;
      } else if (this.estimateWrap) {
        this.estimateWrap.hidden = true;
      }

      this.showError("");
    },

    setStepChrome: function (step) {
      var cfg = this.config || {};
      this.step = step;

      if (step === "size") {
        if (this.eyebrowEl) this.eyebrowEl.textContent = "Step 1 of 2";
        if (this.titleEl) {
          this.titleEl.textContent = cfg.workflowTitle || "Choose your box size";
        }
        if (this.helperEl) {
          this.helperEl.textContent =
            cfg.workflowHelper ||
            "Select the box size that fits your table.";
        }
        if (this.primaryBtn) {
          this.primaryBtn.textContent = cfg.confirmSizeLabel || "Continue";
        }
        if (this.backBtn) this.backBtn.hidden = true;
        if (this.cancelBtn) this.cancelBtn.hidden = false;
      } else {
        if (this.eyebrowEl) this.eyebrowEl.textContent = "Step 2 of 2";
        if (this.titleEl) {
          this.titleEl.textContent =
            cfg.shippingTitle || "Choose shipping option";
        }
        if (this.helperEl) {
          this.helperEl.textContent =
            cfg.shippingHelper ||
            "We ship seafood on Mondays and Tuesdays to protect quality in transit.";
        }
        if (this.primaryBtn) {
          this.primaryBtn.textContent =
            cfg.confirmShippingLabel || "Add to cart";
        }
        if (this.backBtn) {
          this.backBtn.hidden = !this.hasSizeChoices();
          var backLabel = this.backBtn.querySelector("span");
          if (backLabel && cfg.backLabel) backLabel.textContent = cfg.backLabel;
        }
        if (this.cancelBtn) this.cancelBtn.hidden = true;
      }

      this.updateActionGrid();
    },

    updateActionGrid: function () {
      var actions = this.root.querySelector(
        ".ks-box-size-atc-workflow__actions"
      );
      if (!actions) return;
      var visible = Array.prototype.filter.call(actions.children, function (el) {
        return !el.hidden;
      });
      actions.style.gridTemplateColumns =
        visible.length > 2
          ? "1fr 1fr 1.2fr"
          : visible.length === 1
            ? "1fr"
            : "1fr 1fr";
    },

    goToSizeStep: function () {
      var self = this;
      this.showError("");
      this.transitionSteps(this.shippingStep, this.sizeStep, function () {
        self.setStepChrome("size");
        var checked = self.sizeMount.querySelector(
          'input[type="radio"]:checked:not(:disabled)'
        );
        (checked || self.sizeMount.querySelector("input[type='radio']"))?.focus?.(
          { preventScroll: true }
        );
      });
    },

    goToShippingStep: function () {
      var self = this;
      var KS = getKS();
      this.showError("");

      if (
        this.selectedShipping &&
        (!KS ||
          !KS.isValidShippingOption ||
          KS.isValidShippingOption(this.selectedShipping))
      ) {
        this.selectShipping(this.selectedShipping);
        this.collapseShipping(true);
      } else if (KS && KS.hasStoredOption()) {
        this.selectShipping(KS.getStoredOption());
        this.collapseShipping(true);
      } else {
        this.expandShipping();
        this.selectShipping("");
        if (this.estimateWrap) this.estimateWrap.hidden = true;
      }
      this.renderPromoStatus();

      this.transitionSteps(this.sizeStep, this.shippingStep, function () {
        self.setStepChrome("shipping");
        if (self.selectedShipping) self.collapseShipping(true);
        var focusTarget =
          self.root.querySelector(
            ".ks-box-size-atc-workflow__option.is-selected"
          ) || self.root.querySelector(".ks-box-size-atc-workflow__option");
        focusTarget?.focus?.({ preventScroll: true });
      });
    },

    transitionSteps: function (fromEl, toEl, done) {
      if (!fromEl || !toEl) {
        if (done) done();
        return;
      }

      if (prefersReducedMotion() || this.transitioning) {
        fromEl.hidden = true;
        fromEl.classList.remove("is-active", "is-leaving", "is-entering");
        toEl.hidden = false;
        toEl.classList.add("is-active");
        toEl.classList.remove("is-leaving", "is-entering");
        if (done) done();
        return;
      }

      var self = this;
      this.transitioning = true;
      fromEl.classList.add("is-leaving");

      window.setTimeout(function () {
        fromEl.hidden = true;
        fromEl.classList.remove("is-active", "is-leaving");
        toEl.hidden = false;
        toEl.classList.add("is-entering");
        requestAnimationFrame(function () {
          toEl.classList.add("is-active");
          toEl.classList.remove("is-entering");
          self.transitioning = false;
          if (done) done();
        });
      }, 180);
    },

    needsShippingStep: function () {
      var host = this.productFormHost;
      var form = this.form;
      var attr = "";
      if (host && host.dataset) attr = host.dataset.ksRequiresShipping || "";
      if (!attr && form && form.dataset) attr = form.dataset.ksRequiresShipping || "";
      if (attr === "false") return false;
      return true;
    },

    onPrimary: function () {
      if (this._adding) return;
      if (this.step === "size") {
        this.confirmSize();
      } else {
        this.confirmShipping();
      }
    },

    confirmSize: function () {
      var checked = this.sizeMount.querySelector(
        'input[type="radio"]:checked:not(:disabled)'
      );
      if (!checked || !checked.getAttribute("data-variant-id")) {
        this.showError("Please choose a box size to continue.");
        var first = this.sizeMount.querySelector(
          'input[type="radio"]:not(:disabled)'
        );
        first?.focus?.();
        return;
      }

      this.selectedVariantId = checked.getAttribute("data-variant-id");
      this.applyVariantToForm();

      if (this.needsShippingStep()) {
        this.goToShippingStep();
        return;
      }

      this.finishAndSubmit();
    },

    confirmShipping: function () {
      var KS = getKS();
      if (
        !this.selectedShipping ||
        (KS && !KS.isValidShippingOption(this.selectedShipping))
      ) {
        this.showError(
          "Please choose a shipping option before adding this item to your cart."
        );
        this.root
          .querySelector(".ks-box-size-atc-workflow__option")
          ?.focus?.();
        return;
      }

      this.finishAndSubmit();
    },

    resolveSelectedVariantId: function () {
      if (this.sizeMount) {
        var checked = this.sizeMount.querySelector(
          'input[type="radio"]:checked:not(:disabled)'
        );
        var fromMount = checked
          ? String(checked.getAttribute("data-variant-id") || "").trim()
          : "";
        if (/^\d+$/.test(fromMount)) {
          this.selectedVariantId = fromMount;
          return fromMount;
        }
      }
      var id = String(this.selectedVariantId || "").trim();
      if (!/^\d+$/.test(id) && this.form) {
        id = String(this.form.getAttribute("data-ks-forced-variant-id") || "").trim();
        if (!/^\d+$/.test(id)) {
          var input = this.form.querySelector('[name="id"]');
          id = input ? String(input.value || "").trim() : "";
        }
      }
      if (!/^\d+$/.test(id)) return "";
      this.selectedVariantId = id;
      return id;
    },

    applyVariantToForm: function () {
      if (!this.resolveSelectedVariantId() || !this.form) return;
      var idInput =
        this.form.querySelector("[data-ks-box-size-variant-id]") ||
        this.form.querySelector('[name="id"]');
      if (idInput) {
        idInput.value = this.selectedVariantId;
        idInput.removeAttribute("disabled");
      }
      this.form.setAttribute("data-ks-forced-variant-id", this.selectedVariantId);
    },

    beginProgress: function () {
      var self = this;
      this._adding = true;
      if (this.primaryBtn) {
        this.primaryBtn.disabled = true;
        this._primaryLabel = this.primaryBtn.textContent;
        this.primaryBtn.textContent = "Adding to cart…";
      }
      if (this.backBtn) this.backBtn.disabled = true;
      window.clearTimeout(this._progressTimer);
      window.clearTimeout(this._stillTimer);
      this._progressTimer = window.setTimeout(function () {
        if (!self._adding || !self.progressEl) return;
        self.progressEl.hidden = false;
        if (self.progressLabel) {
          self.progressLabel.textContent = self._phaseLabel || "Preparing order…";
        }
      }, 420);
      this._stillTimer = window.setTimeout(function () {
        if (!self._adding) return;
        self.setPhase("Still working…");
        if (self.progressEl) self.progressEl.hidden = false;
      }, 4000);
      this.setPhase("Preparing order…");
    },

    setPhase: function (label) {
      this._phaseLabel = label || "";
      if (this.progressEl && !this.progressEl.hidden && this.progressLabel) {
        this.progressLabel.textContent = this._phaseLabel;
      }
    },

    endProgress: function () {
      this._adding = false;
      window.clearTimeout(this._progressTimer);
      window.clearTimeout(this._stillTimer);
      if (this.progressEl) this.progressEl.hidden = true;
      if (this.primaryBtn) {
        this.primaryBtn.disabled = false;
        if (this._primaryLabel) this.primaryBtn.textContent = this._primaryLabel;
      }
      if (this.backBtn) this.backBtn.disabled = false;
    },

    bindViewport: function () {
      var self = this;
      if (this._viewportBound) return;
      this._viewportBound = true;

      this._keyboardTimers = [];

      this._clearKeyboardTimers = function () {
        self._keyboardTimers.forEach(function (id) {
          window.clearTimeout(id);
        });
        self._keyboardTimers = [];
      };

      this._resetPanelFrame = function () {
        self._clearKeyboardTimers();
        self._aligningPromo = false;
        if (!self.panel) return;
        self.panel.classList.remove("is-keyboard-open");
        self.panel.style.maxHeight = "";
        self.panel.style.top = "";
        self.panel.style.bottom = "";
        self.panel.style.transform = "";
        self.panel.style.transition = "";
      };

      this._promoKeyboardActive = function () {
        if (!self.panel || !self.promoInput || !self.root || self.root.hidden) return false;
        if (document.activeElement !== self.promoInput) return false;
        var vv = window.visualViewport;
        var narrow = window.innerWidth < 750;
        var keyboard = !!(vv && window.innerHeight - vv.height > 60);
        return narrow || keyboard;
      };

      this._placePanelForKeyboard = function () {
        if (!self._promoKeyboardActive()) return;
        var vv = window.visualViewport;
        if (!vv) return;
        var rootTop = self.root.getBoundingClientRect().top;
        self.panel.classList.add("is-keyboard-open");
        self.panel.style.transition = "none";
        self.panel.style.transform = "translateX(-50%)";
        self.panel.style.bottom = "auto";
        self.panel.style.top = Math.round(8 - rootTop) + "px";
        self.panel.style.maxHeight = Math.max(220, Math.round(vv.height - 16)) + "px";
      };

      this._revealPromoField = function () {
        if (self._aligningPromo || !self._promoKeyboardActive()) return;
        var row = self.promoInput.closest(".ks-box-size-atc-workflow__promo") || self.promoInput;
        var panelRect = self.panel.getBoundingClientRect();
        var rowRect = row.getBoundingClientRect();
        var pad = 12;
        var below = rowRect.bottom - (panelRect.bottom - pad);
        var above = panelRect.top + pad - rowRect.top;
        if (below <= 2 && above <= 2) return;
        self._aligningPromo = true;
        self.panel.scrollTop += below > 2 ? below : -above;
        self._aligningPromo = false;
      };

      this._syncPromoKeyboard = function () {
        if (!self._promoKeyboardActive()) {
          if (self.panel && self.panel.classList.contains("is-keyboard-open")) {
            self._resetPanelFrame();
          }
          return;
        }
        self._placePanelForKeyboard();
        window.requestAnimationFrame(function () {
          self._revealPromoField();
        });
      };

      this._schedulePromoKeyboardSync = function () {
        self._clearKeyboardTimers();
        [0, 60, 140, 280, 450, 700].forEach(function (delay) {
          self._keyboardTimers.push(
            window.setTimeout(self._syncPromoKeyboard, delay)
          );
        });
      };

      if (window.visualViewport) {
        window.visualViewport.addEventListener("resize", this._syncPromoKeyboard);
        window.visualViewport.addEventListener("scroll", this._syncPromoKeyboard);
      }
      window.addEventListener("scroll", this._syncPromoKeyboard, { passive: true });
      if (this.panel) {
        this.panel.addEventListener("scroll", function () {
          if (!self._promoKeyboardActive()) return;
          self._revealPromoField();
        });
      }
      if (this.promoInput) {
        this.promoInput.addEventListener("focus", this._schedulePromoKeyboardSync);
        this.promoInput.addEventListener("blur", function () {
          window.setTimeout(function () {
            if (document.activeElement === self.promoInput) return;
            self._resetPanelFrame();
          }, 80);
        });
      }
    },

    finishAndSubmit: function () {
      var self = this;
      var Gate = getGate();
      var KS = getKS();

      if (this._adding) return;
      if (!this.resolveSelectedVariantId()) {
        this.showError("Please choose a box size to continue.");
        return;
      }

      this.applyVariantToForm();
      if (this.form) this.form.setAttribute("data-ks-variant-locked", "1");

      var failMessage =
        (KS && KS.SYNC_FAIL_MESSAGE) ||
        "We couldn't update shipping for every item in your cart. Please try again.";
      var succeed = function () {
        self.endProgress();
        self._confirmedClose = true;
        self.close();
      };
      var fail = function (err) {
        self.endProgress();
        self.showError((err && err.message) || failMessage);
      };

      if (KS && typeof KS.atcTimingStart === "function") KS.atcTimingStart();
      this.beginProgress();

      if (typeof this.onConfirm === "function") {
        var confirmed = {
          shippingValue: this.selectedShipping,
          estimatedShipDate: KS
            ? KS.getEstimatedShipDateForOption(this.selectedShipping)
            : "",
          variantId: this.selectedVariantId,
        };
        var persistConfirmed = Gate && typeof Gate.persistSelection === "function"
          ? Gate.persistSelection({
              shippingValue: confirmed.shippingValue,
              estimatedShipDate: confirmed.estimatedShipDate,
            })
          : Promise.resolve();
        self.setPhase("Updating shipping…");
        persistConfirmed
          .then(function () {
            self.setPhase("Adding to cart…");
            return self.onConfirm(confirmed);
          })
          .then(succeed)
          .catch(fail);
        return;
      }

      var afterPersist = function () {
        if (self.form) {
          self.form.setAttribute("data-ks-purchase-confirmed", "1");
          if (self.selectedVariantId) {
            self.form.setAttribute("data-ks-forced-variant-id", self.selectedVariantId);
          }
          var premium = self.form.closest("[data-ks-premium-buy-flow]");
          if (premium) premium.setAttribute("data-ks-size-ready", "true");
        }
        if (!self.form) return Promise.resolve();

        var shippingPayload = {
          shippingValue: self.selectedShipping,
          estimatedShipDate: KS
            ? KS.getEstimatedShipDateForOption(self.selectedShipping)
            : "",
        };
        var productForm = self.form.closest("product-form");
        if (productForm && typeof productForm.submitLocked === "function") {
          self.setPhase("Adding to cart…");
          return Promise.resolve(
            productForm.submitLocked(self.selectedVariantId, shippingPayload)
          );
        }

        // product-form.js loads on the first submit. Keep the confirmed flag
        // so that replay cannot reopen Step 1, then add from the upgraded element.
        return new Promise(function (resolve, reject) {
          var form = self.form;
          var variantId = self.selectedVariantId;
          var onReady = function (event) {
            if (event.target !== form) return;
            var upgraded = form.closest("product-form");
            if (!upgraded || typeof upgraded.submitLocked !== "function") return;
            event.preventDefault();
            event.stopImmediatePropagation();
            document.removeEventListener("submit", onReady, true);
            self.setPhase("Adding to cart…");
            Promise.resolve(
              upgraded.submitLocked(variantId, shippingPayload)
            ).then(resolve, reject);
          };
          document.addEventListener("submit", onReady, true);

          var submitBtn =
            form.querySelector("[data-ks-box-size-form-submit]") ||
            form.querySelector('[type="submit"]');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute("aria-disabled");
            submitBtn.removeAttribute("data-ks-premium-atc-locked");
          }
          try {
            if (typeof form.requestSubmit === "function") {
              if (submitBtn) form.requestSubmit(submitBtn);
              else form.requestSubmit();
            } else {
              form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
            }
          } catch (err) {
            form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
          }
        });
      };

      var runPersist = function () {
        if (
          self.selectedShipping &&
          Gate &&
          typeof Gate.persistSelection === "function"
        ) {
          var result = Gate.buildResult
            ? Gate.buildResult(self.selectedShipping)
            : {
                shippingValue: self.selectedShipping,
                estimatedShipDate: KS
                  ? KS.getEstimatedShipDateForOption(self.selectedShipping)
                  : "",
              };
          self.setPhase("Updating shipping…");
          return Gate.persistSelection(result);
        }
        if (
          self.selectedShipping &&
          KS &&
          typeof KS.syncCartShippingSelection === "function"
        ) {
          self.setPhase("Updating shipping…");
          return KS.syncCartShippingSelection(self.selectedShipping);
        }
        return Promise.resolve();
      };

      runPersist()
        .then(function () {
          return afterPersist();
        })
        .then(succeed)
        .catch(fail);
    },

    trapFocus: function (event) {
      var focusables = this.panel.querySelectorAll(
        'button:not([hidden]):not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      var list = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!list.length) return;

      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    open: function (options) {
      options = options || {};
      this.ensureMounted();

      this.config = options.config || getConfig() || {};
      this.form = options.form || null;
      this.productFormHost = this.form
        ? this.form.closest("product-form") || this.form
        : null;
      this.previousFocus = options.trigger || document.activeElement;
      this.onConfirm = typeof options.onConfirm === "function" ? options.onConfirm : null;
      this.promoEl = options.promoElement || null;
      this.onCancel = typeof options.onCancel === "function" ? options.onCancel : null;
      this._confirmedClose = false;
      var incomingVariantId = String(options.variantId || "").trim();
      this.selectedVariantId = /^\d+$/.test(incomingVariantId) ? incomingVariantId : "";
      if (this.form) {
        var keepLocked = this.form.getAttribute("data-ks-variant-locked") === "1";
        if (this.selectedVariantId) {
          this.form.setAttribute("data-ks-forced-variant-id", this.selectedVariantId);
        } else if (!keepLocked) {
          this.form.removeAttribute("data-ks-forced-variant-id");
        }
        if (!keepLocked) this.form.removeAttribute("data-ks-variant-locked");
      }
      this.selectedShipping = "";
      this.step = "size";
      this.transitioning = false;
      this.showPromoError("");

      this.applyAccent(this.config.accentColor);

      if (this.productEl) {
        if (options.productTitle) {
          this.productEl.textContent = options.productTitle;
          this.productEl.hidden = false;
        } else {
          this.productEl.textContent = "";
          this.productEl.hidden = true;
        }
      }

      if (this.sizeMount) {
        this.sizeMount.innerHTML = "";
        if (options.template) {
          this.sizeMount.appendChild(options.template.content.cloneNode(true));
        }
      }

      this.sizeStep.hidden = false;
      this.sizeStep.classList.add("is-active");
      this.sizeStep.classList.remove("is-leaving", "is-entering");
      this.shippingStep.hidden = true;
      this.shippingStep.classList.remove("is-active", "is-leaving", "is-entering");
      if (this.estimateWrap) this.estimateWrap.hidden = true;
      this.showError("");
      this.setStepChrome("size");

      var requestedId = String(options.variantId || this.selectedVariantId || "").trim();
      var checked = null;
      if (/^\d+$/.test(requestedId) && this.sizeMount) {
        this.sizeMount.querySelectorAll('input[type="radio"]').forEach(function (el) {
          var match = el.getAttribute("data-variant-id") === requestedId;
          el.checked = match;
          if (match) checked = el;
        });
      }
      if (!checked && this.sizeMount) {
        checked = this.sizeMount.querySelector(
          'input[type="radio"]:checked:not(:disabled)'
        );
      }
      if (checked) {
        this.onSizeSelected(checked);
        this.applyVariantToForm();
      }

      this.root.hidden = false;
      document.body.classList.add("ks-box-size-atc-workflow-open");
      this.renderPromoStatus();

      var self = this;
      var startShipping = options.startStep === "shipping" && (this.selectedVariantId || !this.hasSizeChoices());
      requestAnimationFrame(function () {
        self.root.classList.add("is-open");
        if (startShipping && self.needsShippingStep()) {
          self.goToShippingStep();
          return;
        }
        var focusTarget =
          self.sizeMount.querySelector(
            'input[type="radio"]:checked:not(:disabled)'
          ) ||
          self.sizeMount.querySelector('input[type="radio"]:not(:disabled)');
        if (focusTarget) {
          focusTarget.focus({ preventScroll: true });
        } else {
          self.primaryBtn?.focus?.({ preventScroll: true });
        }
      });
    },

    close: function () {
      if (!this.root) return;

      if (typeof this._resetPanelFrame === "function") this._resetPanelFrame();
      this.root.classList.remove("is-open");
      document.body.classList.remove("ks-box-size-atc-workflow-open");

        var previousFocus = this.previousFocus;
        var cancel = this._confirmedClose ? null : this.onCancel;
        var confirmedClose = this._confirmedClose;
        this.previousFocus = null;
        this.onConfirm = null;
        this.onCancel = null;
        this._confirmedClose = false;
        if (typeof cancel === "function") cancel();

        setTimeout(
          function () {
            this.root.hidden = true;
            if (this.sizeMount) this.sizeMount.innerHTML = "";
          }.bind(this),
          280
        );

        if (confirmedClose) return;

        try {
          previousFocus?.focus?.({ preventScroll: true });
        } catch (_) {
          previousFocus?.focus?.();
        }
    },
  };

  function findTemplateForForm(formId) {
    if (!formId) return null;
    return document.querySelector(
      'template[data-ks-box-size-workflow-template][data-ks-box-size-form="' +
        formId +
        '"]'
    );
  }

  function onOpenClick(event) {
    var trigger = event.target.closest("[data-ks-box-size-atc-open]");
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var config = getConfig(trigger);
    if (config && config.enable === false) return;

    var formId = trigger.getAttribute("data-ks-box-size-form");
    var form = formId ? document.getElementById(formId) : null;
    var template = findTemplateForForm(formId);

    if (!form || !template) return;

    var cardRoot = trigger.closest("[data-ks-grid-card-quick-add]");
    var qtyInput = cardRoot
      ? cardRoot.querySelector("[data-ks-grid-card-qty-input]")
      : null;
    if (qtyInput && cardRoot) {
      var hidden = form.querySelector("[data-ks-grid-card-qty-field]");
      if (hidden) hidden.value = String(qtyInput.value || "1");
    }

    WorkflowUI.open({
      trigger: trigger,
      form: form,
      template: template,
      productTitle: trigger.getAttribute("data-ks-box-size-product-title") || "",
      config: config,
    });
  }

  function cloneSizeTemplate(sizeRoot) {
    if (!sizeRoot) return null;
    var wrap = document.createElement("div");
    wrap.className = "ks-box-size-atc-workflow__size-content";
    wrap.innerHTML = sizeRoot.outerHTML;
    wrap.querySelectorAll("[id]").forEach(function (el) {
      var oldId = el.id;
      var nextId = "ks-wf-clone-" + oldId;
      el.id = nextId;
      wrap.querySelectorAll('label[for="' + oldId + '"]').forEach(function (label) {
        label.setAttribute("for", nextId);
      });
    });
    wrap.querySelectorAll("input, select, textarea").forEach(function (el) {
      el.removeAttribute("form");
      if (el.name) el.name = "ks-wf-clone-" + el.name;
    });
    var template = document.createElement("template");
    template.content.appendChild(wrap);
    return template;
  }

  function openFromProductForm(form, trigger) {
    if (!form || !window.KSBoxSizeAtcWorkflow) return;
    var section = form.closest("section") || document;
    var sizeRoot = null;
    section.querySelectorAll(".ks-box-size-options").forEach(function (el) {
      if (!sizeRoot && !el.closest("#" + ROOT_ID)) sizeRoot = el;
    });
    var triggerVariantId =
      trigger && trigger.getAttribute
        ? String(trigger.getAttribute("data-variant-id") || "").trim()
        : "";
    var checked = null;
    if (/^\d+$/.test(triggerVariantId) && sizeRoot) {
      checked = sizeRoot.querySelector(
        'input[type="radio"][data-variant-id="' + triggerVariantId + '"]'
      );
    }
    if (!checked && sizeRoot) {
      checked = sizeRoot.querySelector(
        'input[type="radio"]:checked:not(:disabled)'
      );
    }
    var idInput = form.querySelector('[name="id"]');
    var variantId = /^\d+$/.test(triggerVariantId)
      ? triggerVariantId
      : checked && checked.getAttribute("data-variant-id")
        ? checked.getAttribute("data-variant-id")
        : idInput
          ? idInput.value
          : "";
    if (checked && idInput && variantId) {
      idInput.disabled = false;
      idInput.value = variantId;
    }
    var titleEl = section.querySelector(".product__title, .product__title h1, h1");
    WorkflowUI.open({
      trigger: trigger || document.activeElement,
      form: form,
      template: cloneSizeTemplate(sizeRoot),
      productTitle: titleEl ? titleEl.textContent.trim() : "",
      variantId: variantId,
      startStep: checked || !sizeRoot ? "shipping" : "size",
      config: getConfig(form),
    });
  }

  function onProductSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== "FORM") return;
    if (form.getAttribute("data-type") !== "add-to-cart-form") return;
    if (
      form.getAttribute("data-ks-purchase-confirmed") === "1" ||
      form.getAttribute("data-ks-variant-locked") === "1"
    ) {
      return;
    }
    if (form.closest("[data-ks-byob], [data-ks-byob-builder]")) return;
    var host = form.closest("product-form");
    if (host && host.dataset && host.dataset.ksRequiresShipping === "false") return;
    event.preventDefault();
    event.stopPropagation();
    openFromProductForm(form, event.submitter || document.activeElement);
  }

  function bind() {
    if (document.body.dataset.ksBoxSizeAtcWorkflowBound === "true") return;
    document.body.dataset.ksBoxSizeAtcWorkflowBound = "true";
    document.addEventListener("click", onOpenClick);
    document.addEventListener("submit", onProductSubmit, true);
    document.addEventListener("change", function (event) {
      var input = event.target;
      if (!input || input.type !== "radio") return;
      var optionsRoot = input.closest(".ks-box-size-options");
      if (!optionsRoot || input.closest("#" + ROOT_ID)) return;
      var form = input.getAttribute("form")
        ? document.getElementById(input.getAttribute("form"))
        : null;
      if (!form) {
        var host = input.closest("[data-ks-premium-buy-flow], product-form, section");
        form = host && host.querySelector('form[data-type="add-to-cart-form"]');
      }
      if (!form) return;
      if (
        form.getAttribute("data-ks-variant-locked") === "1" ||
        form.getAttribute("data-ks-purchase-confirmed") === "1"
      ) {
        return;
      }
      var variantId = input.getAttribute("data-variant-id");
      if (variantId) {
        var idInput = form.querySelector('[name="id"]');
        if (idInput) {
          idInput.disabled = false;
          idInput.value = variantId;
        }
        form.setAttribute("data-ks-forced-variant-id", variantId);
      }
      var modal = document.getElementById(ROOT_ID);
      if (modal && modal.classList.contains("is-open")) {
        if (/^\d+$/.test(String(variantId || ""))) {
          WorkflowUI.selectedVariantId = variantId;
          if (WorkflowUI.sizeMount) {
            WorkflowUI.sizeMount
              .querySelectorAll('input[type="radio"]')
              .forEach(function (el) {
                el.checked = el.getAttribute("data-variant-id") === variantId;
              });
          }
          WorkflowUI.form = form;
          WorkflowUI.applyVariantToForm();
        }
        return;
      }
      openFromProductForm(form, input);
    });
  }

  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    bind();
  } else {
    document.addEventListener("DOMContentLoaded", bind);
  }

  window.KSBoxSizeAtcWorkflow = {
    open: function (options) {
      WorkflowUI.open(options || {});
    },
    close: function () {
      WorkflowUI.close();
    },
    setPhase: function (label) {
      WorkflowUI.setPhase(label);
    },
  };
})();
